(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casanova-base"] && !Shopify.designMode) return;
  try {
    
  /**
   * Bottone di preordine che segue lo scorrimento.
   *
   * Entra passata la hero. Esce quando a schermo arriva qualcosa che dice
   * gia' la stessa cosa meglio di lui: la chiamata finale, il riquadro
   * d'acquisto vero, il piede con termini e informative.
   *
   * Usa IntersectionObserver e non un ascoltatore di scorrimento, quindi non
   * fa lavorare il thread principale a ogni fotogramma.
   */
  class CasanovaBar extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('cas-bar--in');
        return;
      }

      const hero = document.querySelector('.cas-hero');

      // Senza hero in pagina — per esempio la scheda prodotto — il bottone
      // e' utile da subito.
      this.oltreLaHero = !hero;
      this.coperti = new Set();
      this.osservatori = [];

      if (hero) {
        this.osservatoreHero = new IntersectionObserver(
          ([e]) => {
            this.oltreLaHero = !e.isIntersecting;
            this.sincronizza();
          },
          { rootMargin: '-45% 0px 0px 0px' }
        );
        this.osservatoreHero.observe(hero);
      }

      // I motivi per sparire, che poi sono lo stesso motivo detto in piu'
      // posti: dove c'e' gia' un'azione vera da compiere, un invito sopra
      // le toglie forza invece di aggiungerne — o, peggio, la copre.
      //
      //   - la chiamata finale della home;
      //   - il riquadro d'acquisto vero, sulla scheda prodotto;
      //   - il bottone "Invia" del modulo contatti: il bottone fisso ci stava
      //     sopra, e chi aveva appena scritto un messaggio non lo poteva
      //     mandare senza scorrere ancora;
      //   - il bottone di pagamento del carrello, per lo stesso motivo: nel
      //     momento in cui uno sta per pagare, un invito a preordinare e'
      //     rumore sopra l'unico gesto che conta;
      //   - il piede, dove stanno termini e informative. Un bottone fisso che
      //     copre i link legali nasconde proprio quello che il cliente deve
      //     poter leggere prima di comprare, e su quasi tutte le pagine il
      //     piede e' l'unico posto dove quei link esistono.
      //
      // Il margine allarga il bordo basso dello schermo: l'elemento conta
      // come arrivato un po' prima di esserlo, cosi' il bottone se ne va
      // prima di coprirlo invece che mentre lo copre.
      const piede = document.querySelector('footer .utilities') || document.querySelector('footer');

      // Sulla scheda il riquadro d'acquisto e' alto: su un portatile da 768
      // pixel il bottone fisso arrivava a coprire prezzo ed edizioni mentre
      // il bottone vero era ancora sotto la piega. Si guarda tutta la zona,
      // non solo i bottoni.
      const zonaAcquisto = document.querySelectorAll(
        '.buy-buttons-block, variant-picker, .cas-ediz, .cas-preordine, .price, product-price'
      );

      const bersagli = [
        [document.querySelector('.cas-closing'), '0px 0px -20% 0px'],
        [document.querySelector('.contact-form .submit-button'), '0px 0px 140px 0px'],
        [document.querySelector('button[name="checkout"]'), '0px 0px 140px 0px'],
        [piede, '0px 0px 140px 0px'],
      ];

      for (const zona of zonaAcquisto) bersagli.push([zona, '0px 0px 40px 0px']);

      for (const [elemento, margine] of bersagli) {
        if (!elemento) continue;
        const osservatore = new IntersectionObserver(
          ([e]) => {
            if (e.isIntersecting) this.coperti.add(elemento);
            else this.coperti.delete(elemento);
            this.sincronizza();
          },
          { rootMargin: margine }
        );
        osservatore.observe(elemento);
        this.osservatori.push(osservatore);
      }

      // Sulla scheda prodotto il link punta alla pagina in cui siamo gia':
      // cliccarlo ricarica la stessa pagina e riporta in cima, cioe' fa
      // perdere il posto invece di far comprare. Qui porta al riquadro
      // d'acquisto, che e' quello che uno voleva premendolo. Dal 2/10/2026
      // allo stesso punto dei link #preordina: il titolo del prodotto in
      // cima e sotto tutto fino al pagamento veloce (il margine lo calcola
      // il blocco del preordine).
      const link = this.querySelector('.cas-bar__cta');
      const acquisto = document.querySelector('.buy-buttons-block');
      const ancora = document.getElementById('preordina');

      if (link && acquisto && link.pathname === window.location.pathname) {
        link.addEventListener('click', (evento) => {
          evento.preventDefault();
          const fermi = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (ancora) ancora.scrollIntoView({ behavior: fermi ? 'auto' : 'smooth', block: 'start' });
          else acquisto.scrollIntoView({ behavior: fermi ? 'auto' : 'smooth', block: 'center' });
          // Senza fuoco, chi naviga da tastiera resta col cursore sul bottone
          // fisso mentre la pagina si e' spostata altrove. preventScroll
          // perche' lo spostamento lo sta gia' facendo la riga sopra.
          acquisto.querySelector('button:not([disabled])')?.focus({ preventScroll: true });
        });
      }

      this.sincronizza();
    }

    disconnectedCallback() {
      this.osservatoreHero?.disconnect();
      for (const osservatore of this.osservatori ?? []) osservatore.disconnect();
    }

    sincronizza() {
      this.classList.toggle('cas-bar--in', this.oltreLaHero && this.coperti.size === 0);
    }
  }

  if (!customElements.get('casanova-bar')) {
    customElements.define('casanova-bar', CasanovaBar);
  }

  /**
   * Rivelazioni all'ingresso in vista.
   *
   * Sostituisce `animation-timeline: view()`, che e' recente e sui telefoni
   * con browser meno aggiornati non fa nulla: il contenuto restava fermo e
   * l'effetto non si vedeva. Qui basta un osservatore e una classe.
   *
   * Una volta rivelato, l'elemento smette di essere osservato: la
   * rivelazione avviene una volta sola e tornando su non si riavvolge, che e'
   * quello che la gente si aspetta.
   *
   * L'elenco dei selettori esiste in due copie, qui e nel CSS dei token:
   * se ne aggiungi uno, aggiungilo di la'.
   */
  (function rivelazioni() {
    const SINGOLI = [
      '.cas-roles__head',
      '.cas-world__head',
      '.cas-contents__head',
      '.cas-turno__head',
      '.cas-tavolo__head',
      '.cas-faq__head',
      '.cas-recensioni__head',
      '.cas-craft__body',
      '.cas-amae__grid',
      '.cas-closing__body',
      '.cas-amae__slogan',
      '.cas-chi__head',
      '.cas-chi__marchio',
      '.cas-chi__slogan',
      '.cas-chi__motto-body',
    ];

    // Questi arrivano in gruppo: entrano sfalsati, non tutti insieme.
    const GRUPPI = [
      '.cas-roles__item',
      '.cas-contents__card',
      '.cas-world__luogo',
      '.cas-world__hazard',
      '.cas-turno__passo',
      '.cas-tavolo__passo',
      '.cas-craft__point',
      '.cas-amae__point',
      '.cas-recensioni__card',
      '.cas-chi__persona',
    ];

    const avvia = () => {
      const elementi = Array.from(document.querySelectorAll([...SINGOLI, ...GRUPPI].join(',')));
      if (!elementi.length) return;

      // Numera ogni elemento dentro il proprio gruppo: il CSS trasforma il
      // numero in ritardo. Fatto qui e non nel CSS perche' :nth-child non
      // sa quanti fratelli dello stesso tipo ci sono davvero.
      for (const sel of GRUPPI) {
        document.querySelectorAll(sel).forEach((el, i) => {
          el.style.setProperty('--cas-ordine', i);
        });
      }

      if (!('IntersectionObserver' in window)) {
        elementi.forEach((el) => el.classList.add('cas-reveal--in'));
        return;
      }

      // Quando parte l'animazione.
      //
      // Prima bastava che l'elemento spuntasse dal bordo basso: il movimento
      // avveniva nell'ultima striscia dello schermo, quella che l'occhio sta
      // gia' scavalcando, e a pagina ferma era finito da un pezzo. Ora il
      // campo di osservazione si ferma a meta' schermo — e' quello che fa il
      // margine negativo in basso — quindi l'elemento "entra" quando il suo
      // bordo alto ha passato la meta': succede davanti agli occhi.
      //
      // Dal 27/9/2026 il campo si ferma a un quarto dal fondo e non a meta':
      // con l'entrata piu' dolce (vedi casanova-tokens) un testo che aspetta
      // meta' schermo per comparire sembrava in ritardo. Ora affiora mentre
      // sale, e finisce di comparire prima di arrivare a meta'.
      const rimasti = new Set(elementi);

      const rivela = (el) => {
        el.classList.add('cas-reveal--in');
        osservatore.unobserve(el);
        rimasti.delete(el);
      };

      const osservatore = new IntersectionObserver(
        (voci) => {
          for (const v of voci) if (v.isIntersecting) rivela(v.target);
        },
        { rootMargin: '0px 0px -25% 0px', threshold: 0 }
      );

      elementi.forEach((el) => osservatore.observe(el));

      // La rete di sicurezza. In fondo alla pagina non si scorre piu': quello
      // che e' rimasto sotto la meta' dello schermo non ci arrivera' mai, e
      // senza questo controllo resterebbe invisibile per sempre. Vale anche
      // per una pagina cosi' corta da non scorrere affatto, ed e' il motivo
      // per cui il controllo parte subito una volta.
      const inFondo = () =>
        window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;

      const controllaFondo = () => {
        if (!rimasti.size) {
          window.removeEventListener('scroll', controllaFondo);
          window.removeEventListener('resize', controllaFondo);
          return;
        }
        if (inFondo()) for (const el of [...rimasti]) rivela(el);
      };

      window.addEventListener('scroll', controllaFondo, { passive: true });
      window.addEventListener('resize', controllaFondo);
      controllaFondo();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', avvia, { once: true });
    } else {
      avvia();
    }
  })();

  /**
   * Gli sfondi sfocati derivano solo mentre si vedono.
   *
   * Ogni sezione ne ha uno: un'immagine sfocata che scivola avanti e indietro
   * in quaranta secondi, per sempre. Su una scheda prodotto lunga dodici
   * schermate sono sette immagini che si muovono insieme, e sei di esse
   * stanno fuori dallo schermo — il telefono ricalcola una sfocatura da 12
   * pixel per qualcosa che nessuno sta guardando.
   *
   * Qui la deriva parte quando la sezione si avvicina e si ferma quando se ne
   * va. Il margine largo la fa cominciare prima che il bordo entri, cosi'
   * nessuno vede l'istante in cui riparte.
   *
   * A differenza delle rivelazioni questo osservatore non lascia mai andare
   * quello che segue: deve accendere E spegnere, non una volta sola.
   */
  (() => {
    const sfondi = document.querySelectorAll('.cas-backdrop');
    if (!sfondi.length || !('IntersectionObserver' in window)) return;

    const osservatore = new IntersectionObserver(
      (voci) => {
        for (const v of voci) v.target.classList.toggle('cas-backdrop--in-vista', v.isIntersecting);
      },
      { rootMargin: '300px 0px 300px 0px' }
    );

    sfondi.forEach((s) => osservatore.observe(s));
  })();

  /**
   * La facciata del video: al primo clic sostituisce copertina e bottone con
   * l'iframe vero, gia' in riproduzione. Sta qui e non nella sezione perche'
   * la facciata la usano due sezioni diverse, e questa e' l'unica che viene
   * caricata su tutte le pagine.
   */
    class CasanovaVideoFacade extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.load, { once: true });
      }

      load = () => {
        const src = this.dataset.embed;
        if (!src) return;

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = this.querySelector('.cas-video__label')?.textContent?.trim() || 'video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.loading = 'eager';

        this.replaceChildren(iframe);
        iframe.focus();
      };
    }

    if (!customElements.get('casanova-video-facade')) {
      customElements.define('casanova-video-facade', CasanovaVideoFacade);
    }

  /**
   * La colonna d'acquisto a misura dello schermo (dal 2/10/2026).
   *
   * Su computer la colonna accanto alla foto riempie l'altezza dello
   * schermo sotto la testata (barra degli annunci e menu): su uno schermo
   * basso la si rimpicciolisce, su uno grande la si ingrandisce, sempre
   * per intero e senza scorrere. Fra il 70% (sotto, le scritte non si
   * leggerebbero) e il 130% (sopra, su uno schermo molto grande
   * diventerebbe enorme). La foto a sinistra prende la stessa altezza
   * della colonna.
   *
   * Sul telefono deve stare in una schermata tutto quello che va dal
   * titolo al pagamento veloce (PayPal, Shop): se non ci sta, si
   * rimpicciolisce, mai sotto l'80%. Li' l'altezza e' quella dello schermo
   * con le barre del browser aperte (svh), che non cambia mentre si scorre.
   *
   * `zoom` e non `scale`: rimpicciolisce e ingrandisce anche lo spazio
   * occupato. Con lo zoom il testo va a capo in altri punti, quindi la
   * misura si rifa' dopo averlo applicato, finche' torna. Lo zoom sta in un
   * foglio di stile suo e non sull'elemento: quando si cambia edizione
   * Horizon ridisegna la colonna e cancellerebbe uno stile scritto
   * sull'elemento. Si rifa' quando cambia la finestra (sul telefono solo
   * se cambia la larghezza), quando arrivano i caratteri e dopo un cambio
   * di edizione; non quando si apre una tendina: chi la apre vuole
   * leggerla. Alla fine avvisa con l'evento amae:colonna-adattata, perche'
   * il blocco del preordine rifaccia i conti del punto d'arrivo.
   */
  (() => {
    const SELETTORE = '.product-information .product-details > .group-block';
    const GALLERIA = '.product-information__media .product-media-container.constrain-height:not(.dialog-zoomed-gallery *)';
    if (!document.querySelector(SELETTORE)) return;

    const computer = window.matchMedia('(min-width: 750px)');
    const foglio = document.createElement('style');
    foglio.id = 'amae-colonna-intera';
    document.head.append(foglio);

    // Un metro alto quanto lo schermo piccolo del telefono (barre aperte).
    const metro = document.createElement('div');
    metro.setAttribute('aria-hidden', 'true');
    metro.style.cssText = 'position:fixed;inset-block-start:0;inline-size:0;block-size:100svh;visibility:hidden;pointer-events:none';
    document.body.append(metro);

    const scrivi = (fattore, galleria) => {
      let css = Math.abs(fattore - 1) < 0.005 ? '' : `${SELETTORE} { zoom: ${fattore.toFixed(3)}; }`;
      if (galleria) {
        css += ` @media (min-width: 750px) { ${GALLERIA} { height: ${galleria}px; max-height: ${galleria}px; aspect-ratio: auto; } ${GALLERIA} .product-media { height: 100%; aspect-ratio: auto; } }`;
      }
      foglio.textContent = css;
    };

    // Sul telefono conta solo il tratto dal titolo al pagamento veloce.
    const trattoTelefono = (colonna) => {
      const inizio = colonna.getBoundingClientRect().top;
      const altre = colonna.querySelector('.shopify-payment-button__more-options');
      const veloce = colonna.querySelector('shopify-accelerated-checkout, .shopify-payment-button');
      const acquisto = colonna.querySelector('.buy-buttons-block');
      let fine = colonna.getBoundingClientRect().bottom;
      if (altre && altre.getBoundingClientRect().height) fine = altre.getBoundingClientRect().top;
      else if (veloce && veloce.getBoundingClientRect().height) fine = veloce.getBoundingClientRect().bottom;
      else if (acquisto) fine = acquisto.getBoundingClientRect().bottom;
      return fine - inizio;
    };

    const adatta = () => {
      const colonna = document.querySelector(SELETTORE);
      if (!colonna) return;
      // Con una tendina aperta la colonna e' lunga per scelta di chi legge:
      // lo zoom resta quello di prima.
      if (colonna.querySelector('details[open]')) return;
      foglio.textContent = '';

      const pc = computer.matches;
      const testata = pc ? parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0 : 0;
      const schermo = pc ? window.innerHeight : metro.getBoundingClientRect().height || window.innerHeight;
      const disponibile = schermo - testata - (pc ? 12 : 24);
      const [minimo, massimo] = pc ? [0.7, 1.3] : [0.8, 1];
      const alto = () => (pc ? colonna.getBoundingClientRect().height : trattoTelefono(colonna));

      const naturale = alto();
      if (!naturale) return;
      let fattore = Math.min(massimo, Math.max(minimo, disponibile / naturale));
      for (let giro = 0; giro < 4; giro++) {
        scrivi(fattore);
        const ora = alto();
        if (ora <= disponibile + 1 || fattore <= minimo) break;
        fattore = Math.max(minimo, (fattore * disponibile) / ora);
      }
      scrivi(fattore, pc ? Math.round(colonna.getBoundingClientRect().height) : 0);
      document.dispatchEvent(new CustomEvent('amae:colonna-adattata'));
    };

    adatta();
    window.addEventListener('load', adatta);
    let larghezza = window.innerWidth;
    window.addEventListener('resize', () => {
      // Sul telefono la finestra cambia altezza quando le barre del browser
      // si chiudono scorrendo: non e' un motivo per ridisegnare.
      if (!computer.matches && window.innerWidth === larghezza) return;
      larghezza = window.innerWidth;
      adatta();
    });
    document.fonts?.ready.then(adatta);
    document.addEventListener('change', (evento) => {
      if (!evento.target.closest?.('variant-picker')) return;
      setTimeout(adatta, 600);
      setTimeout(adatta, 1500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casanova-craft"] && !Shopify.designMode) return;
  try {
    
  /**
   * L'apertura delle maschere segue lo scorrimento.
   *
   * QUANTO SI APRONO. Il bersaglio e' +300% sull'apertura del giro prima
   * (--forza 4). Ma il ventaglio aperto a quella misura e' largo quasi il
   * doppio del collage: le carte prima ruotano e poi si spostano, e a 70
   * gradi di rotazione lo spostamento "in su" diventa quasi tutto di lato.
   * Misurato: sul telefono le maschere laterali uscivano dallo schermo per il
   * 70%, su desktop una usciva a sinistra e l'altra finiva sopra il testo.
   *
   * Quindi la forza non e' un numero fisso: all'avvio e a ogni cambio di
   * dimensione si cerca la piu' alta, fino a 4, per cui a ventaglio aperto
   * ogni maschera resta dentro lo schermo, non passa sopra la colonna del
   * testo e non esce dalla sezione in alto. Dove lo spazio c'e' arriva a 4;
   * dove non c'e' si ferma prima, invece di tagliare le maschere.
   *
   * QUANDO SI APRONO. Dipende da quanto il centro del collage dista dal
   * centro dello schermo: tutto aperto entro il 15% dell'altezza dello
   * schermo, chiuso quando il collage e' uscito del tutto, sopra o sotto.
   * Si apre mentre ci si avvicina e si richiude dopo averlo superato.
   *
   * L'ascoltatore dello scorrimento esiste solo mentre il collage e' vicino
   * allo schermo: un IntersectionObserver lo aggancia e lo stacca. Dentro, un
   * requestAnimationFrame: al massimo un calcolo per fotogramma.
   *
   * Chi ha chiesto meno animazioni vede il mazzo fermo e chiuso.
   */
  (function aperturaDelleMaschere() {
    const collage = document.querySelector('.cas-craft__collage');
    if (!collage || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const FORZA_RICHIESTA = 4;
    const sezione = collage.closest('.cas-craft') || collage.parentElement;
    const testo = sezione.querySelector('.cas-craft__body');
    const testa = sezione.querySelector('.cas-craft__head');
    const carte = Array.from(collage.querySelectorAll('.cas-craft__mask'));

    const impostaForza = (valore) => {
      collage.style.setProperty('--forza', String(valore));
      collage.style.setProperty('--forza-x', String(valore));
    };

    /** A ventaglio aperto con questa forza, ogni carta sta al suo posto? */
    const ciSta = (valore) => {
      impostaForza(valore);
      const larghezza = document.documentElement.clientWidth;
      const rc = collage.getBoundingClientRect();
      const rs = sezione.getBoundingClientRect();
      const rt = testo ? testo.getBoundingClientRect() : null;
      // Testo a fianco (desktop): il limite destro e' la sua colonna.
      // Testo sotto (telefono, tablet): il limite e' lo schermo.
      const limiteDestro = rt && rt.left >= rc.right ? rt.left - 16 : larghezza;
      // Titolo sopra il collage (telefono, tablet): il limite in alto e' il
      // titolo. Titolo a fianco (computer): e' l'inizio della sezione.
      const rh = testa ? testa.getBoundingClientRect() : null;
      const limiteAlto = rh && rh.bottom <= rc.top + 1 ? rh.bottom : rs.top;
      return carte.every((carta) => {
        const b = carta.getBoundingClientRect();
        const tolleranza = b.width * 0.05;
        return b.left >= -tolleranza && b.right <= limiteDestro + tolleranza && b.top >= limiteAlto;
      });
    };

    const misuraLaForza = () => {
      const apertura = collage.style.getPropertyValue('--apertura') || '0';
      // Misura senza transizione, altrimenti i rettangoli letti sarebbero a
      // meta' strada. Tutto succede nello stesso giro di JavaScript: il
      // browser non disegna niente in mezzo, e non si vede nessuno scatto.
      carte.forEach((carta) => (carta.style.transition = 'none'));
      collage.style.setProperty('--apertura', '1');

      let basso = 0;
      let alto = FORZA_RICHIESTA;
      if (ciSta(alto)) {
        basso = alto;
      } else {
        for (let i = 0; i < 12; i++) {
          const mezzo = (basso + alto) / 2;
          if (ciSta(mezzo)) basso = mezzo;
          else alto = mezzo;
        }
      }

      impostaForza(basso.toFixed(3));
      collage.style.setProperty('--apertura', apertura);
      carte.forEach((carta) => carta.getBoundingClientRect());
      carte.forEach((carta) => (carta.style.transition = ''));
    };

    let fotogramma = 0;
    let forzaDaRimisurare = true;

    const calcola = () => {
      fotogramma = 0;
      if (forzaDaRimisurare) {
        forzaDaRimisurare = false;
        misuraLaForza();
      }
      const r = collage.getBoundingClientRect();
      const schermo = window.innerHeight;
      const distanza = Math.abs(r.top + r.height / 2 - schermo / 2);
      const tuttoAperto = schermo * 0.15;
      const chiuso = schermo / 2 + r.height / 2;
      let p = 1 - (distanza - tuttoAperto) / (chiuso - tuttoAperto);
      p = Math.min(1, Math.max(0, p));
      // smoothstep: parte e arriva piano, invece di scattare ai due capi
      p = p * p * (3 - 2 * p);
      collage.style.setProperty('--apertura', p.toFixed(3));
    };

    const chiedi = () => {
      if (!fotogramma) fotogramma = requestAnimationFrame(calcola);
    };

    const ridimensionato = () => {
      forzaDaRimisurare = true;
      chiedi();
    };

    // Lo scorrimento si ascolta sul documento in fase di cattura, non sulla
    // finestra. Su computer, da 990 pixel, in Horizon non scorre la pagina ma
    // il contenitore `.page-wrapper`: il suo evento di scorrimento non risale
    // fino alla finestra, e un ascoltatore messo li' non sentiva niente — il
    // ventaglio restava fermo. In cattura il documento lo riceve comunque, da
    // qualunque elemento scorra, e sul telefono, dove scorre la pagina, anche.
    let attivo = false;
    new IntersectionObserver(
      ([voce]) => {
        if (voce.isIntersecting && !attivo) {
          attivo = true;
          document.addEventListener('scroll', chiedi, { passive: true, capture: true });
          window.addEventListener('resize', ridimensionato, { passive: true });
          calcola();
        } else if (!voce.isIntersecting && attivo) {
          attivo = false;
          document.removeEventListener('scroll', chiedi, { capture: true });
          window.removeEventListener('resize', ridimensionato);
          forzaDaRimisurare = true;
          collage.style.setProperty('--apertura', '0');
        }
      },
      // un quarto di schermo di anticipo: quando il collage entra, il calcolo
      // e' gia' agganciato
      { rootMargin: '25% 0px 25% 0px' }
    ).observe(collage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casanova-gondola"] && !Shopify.designMode) return;
  try {
    
  /**
   * La gondola al posto della barra di scorrimento.
   * Vedi il commento in testa alla sezione per il perche' di ogni scelta.
   */
  (function gondola() {
    const radice = document.querySelector('.cas-gondola');
    if (!radice) return;
    const barca = radice.querySelector('.cas-gondola__barca');
    const canale = radice.querySelector('.cas-gondola__canale');
    if (!barca || !canale) return;

    /** Quello che scorre davvero: `.page-wrapper` su computer, la pagina sul telefono. */
    const scorrevole = () => {
      const wrapper = document.querySelector('.page-wrapper');
      if (
        wrapper &&
        wrapper.scrollHeight > wrapper.clientHeight + 1 &&
        getComputedStyle(wrapper).overflowY !== 'visible'
      ) {
        return wrapper;
      }
      return document.scrollingElement || document.documentElement;
    };

    const MARGINE_BASSO = 12;
    const altezzaBarca = () => barca.getBoundingClientRect().height || 66;

    let alto = 12;
    let corsa = 0;
    let ultimoTop = scorrevole().scrollTop;
    let ultimoTempo = performance.now();
    let fotogramma = 0;
    let fermo = 0;
    let nascondi = 0;

    // Il canale comincia sotto il gruppo della testata (avvisi e intestazione).
    // Si misura l'altezza del gruppo e non la posizione dell'intestazione:
    // l'intestazione si nasconde scendendo e ricompare risalendo, e se il
    // canale la seguisse la barca salterebbe su e giu' di settanta pixel.
    const misura = () => {
      const gruppo = document.querySelector('#header-group');
      const testata = gruppo || document.querySelector('header-component, header');
      let h = testata ? testata.offsetHeight : 0;
      // Con l'intestazione trasparente della home il gruppo puo' misurare meno
      // dell'intestazione vera: a inizio pagina conta dove finisce lei.
      const intestazione = document.querySelector('header-component');
      if (intestazione && scorrevole().scrollTop < 5) h = Math.max(h, intestazione.getBoundingClientRect().bottom);
      alto = Math.round(Math.min(h, innerHeight * 0.3) + 10);
      corsa = Math.max(0, innerHeight - alto - MARGINE_BASSO - altezzaBarca());
      radice.style.setProperty('--g-alto', alto + 'px');
    };

    const disegna = () => {
      fotogramma = 0;
      const s = scorrevole();
      const totale = s.scrollHeight - s.clientHeight;
      const p = totale > 0 ? Math.min(1, Math.max(0, s.scrollTop / totale)) : 0;
      radice.style.setProperty('--g-y', (p * corsa).toFixed(1) + 'px');
    };

    const chiedi = () => {
      if (!fotogramma) fotogramma = requestAnimationFrame(disegna);
    };

    const alloScorrimento = () => {
      const s = scorrevole();
      const ora = performance.now();
      const dy = s.scrollTop - ultimoTop;
      const dt = Math.max(16, ora - ultimoTempo);
      ultimoTop = s.scrollTop;
      ultimoTempo = ora;

      if (dy !== 0) {
        // pixel al secondo -> durata di una remata, fra 320 e 950 millisecondi
        const velocita = (Math.abs(dy) / dt) * 1000;
        const durata = Math.round(Math.max(320, Math.min(950, 1300 - velocita * 0.35)));
        radice.style.setProperty('--g-voga', durata + 'ms');
        radice.classList.add('in-voga', 'in-vista');
        // la prua guarda dove si va, e resta cosi' anche da ferma
        radice.classList.toggle('verso-su', dy < 0);
      }

      clearTimeout(fermo);
      fermo = setTimeout(() => radice.classList.remove('in-voga'), 260);

      clearTimeout(nascondi);
      nascondi = setTimeout(() => radice.classList.remove('in-vista'), 1400);

      chiedi();
    };

    // ---------- trascinare la barca, cliccare il canale ----------
    let presa = null;

    const vaiA = (clientY, comportamento) => {
      const s = scorrevole();
      const totale = s.scrollHeight - s.clientHeight;
      const p = corsa > 0 ? (clientY - alto) / corsa : 0;
      s.scrollTo({ top: Math.min(1, Math.max(0, p)) * totale, behavior: comportamento });
    };

    barca.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      e.preventDefault();
      presa = { scarto: e.clientY - barca.getBoundingClientRect().top };
      barca.setPointerCapture(e.pointerId);
      radice.classList.add('is-trascinata');
    });

    barca.addEventListener('pointermove', (e) => {
      if (presa) vaiA(e.clientY - presa.scarto, 'instant');
    });

    const lascia = (e) => {
      if (!presa) return;
      presa = null;
      radice.classList.remove('is-trascinata');
      if (barca.hasPointerCapture(e.pointerId)) barca.releasePointerCapture(e.pointerId);
    };
    barca.addEventListener('pointerup', lascia);
    barca.addEventListener('pointercancel', lascia);

    canale.addEventListener('click', (e) => vaiA(e.clientY - altezzaBarca() / 2, 'smooth'));

    // ---------- avvio ----------
    document.addEventListener('scroll', alloScorrimento, { passive: true, capture: true });
    window.addEventListener(
      'resize',
      () => {
        misura();
        chiedi();
      },
      { passive: true }
    );
    // la pagina si allunga mentre arrivano immagini e sezioni
    if ('ResizeObserver' in window) new ResizeObserver(chiedi).observe(document.body);

    misura();
    disegna();
    document.documentElement.classList.add('cas-gondola-attiva');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casanova-recensioni"] && !Shopify.designMode) return;
  try {
    
  /**
   * Le frecce del nastro delle recensioni.
   *
   * Sul telefono non servono: si scorre con il dito e la fila ha gia' lo
   * scatto d'aggancio. Su computer si': con il mouse la rotella scorre la
   * pagina e non il nastro, quindi senza frecce le schede oltre la terza
   * non le trova nessuno. La barra sotto, che da 48rem torna visibile, dice
   * che c'e' altro; le frecce servono a prenderlo.
   *
   * Compaiono solo se c'e' davvero qualcosa da scorrere — con poche
   * recensioni le schede ci stanno tutte e le frecce sarebbero due bottoni
   * inutili — e quella di un capo sparisce quando si e' arrivati a quel
   * capo. Il passo e' una scheda piu' il divario, letti dal vero: le misure
   * cambiano con la larghezza dello schermo e non vanno scritte due volte.
   */
  (function frecceDelNastro() {
    document.querySelectorAll('.cas-recensioni .cas-nastro-box').forEach((box) => {
      const lista = box.querySelector('.cas-nastro--sempre');
      const prima = box.querySelector('.cas-nastro-freccia--prima');
      const dopo = box.querySelector('.cas-nastro-freccia--dopo');
      if (!lista || !prima || !dopo) return;

      const passo = () => {
        const carta = lista.firstElementChild;
        if (!carta) return lista.clientWidth * 0.8;
        const divario = parseFloat(getComputedStyle(lista).columnGap) || 0;
        return carta.getBoundingClientRect().width + divario;
      };

      const aggiorna = () => {
        const avanzo = lista.scrollWidth - lista.clientWidth;
        box.classList.toggle('cas-nastro-box--con-frecce', avanzo > 4);
        prima.disabled = lista.scrollLeft <= 1;
        dopo.disabled = lista.scrollLeft >= avanzo - 1;
      };

      const scorri = (verso) => {
        lista.scrollBy({ left: verso * passo(), behavior: 'smooth' });
      };

      prima.addEventListener('click', () => scorri(-1));
      dopo.addEventListener('click', () => scorri(1));
      lista.addEventListener('scroll', aggiorna, { passive: true });
      window.addEventListener('resize', aggiorna, { passive: true });
      aggiorna();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
